import {selectIsEmbed} from 'state/environment/environmentSelectors';
import {createSelector} from 'reselect';
import memoize from 'lodash/memoize';
import variadicKeyResolver from 'utilities/variadicKeyResolver';
import {RESOURCE_TYPES} from 'constants/ObjectsConstants';
import {notebookHasDynamicTextOfType} from '../card/cardService';

export const selectViewById = (state, viewId) => state.view.views[viewId];

const reselectViewFiltersByCardId = createSelector(
  state => state.view.views,
  state => state.card.entities,
  (views, cards) =>
    memoize((viewId, cardId) => {
      const card = cards[cardId];
      const view = views[viewId];
      // if it's a notebook card with filter dynamic text, then return all filters
      if (
        card.type === 'Text' &&
        notebookHasDynamicTextOfType(card, 'FILTER')
      ) {
        return view.filters;
      }
      if (!view || !card || !card.datasources) return [];
      const dataSourceIds = new Set(card.datasources.map(s => s.dataSourceId));
      return view.filters.filter(
        f => !f.dataSourceId || dataSourceIds.has(f.dataSourceId)
      );
    }, variadicKeyResolver)
);

export const selectViewFiltersByCardId = (state, viewId, cardId) =>
  reselectViewFiltersByCardId(state)(viewId, cardId);

export const selectCardId = (state, viewId) => {
  const view = selectViewById(state, viewId);
  if (!view) return false;
  const isCardView = view.resourceType === RESOURCE_TYPES.CARD;
  const resourceId = view.resourcePrefix
    ? `${view.resourcePrefix}:${view.resourceId}`
    : String(view.resourceId);
  return isCardView && resourceId;
};

export const selectBackgroundId = (state, viewId) => {
  const view = selectViewById(state, viewId);
  return view && view.backgroundId;
};

export const selectFitToFrame = (state, viewId) => {
  const view = selectViewById(state, viewId);
  return view && view.fitToFrame;
};

export const selectStyles = (state, viewId) => {
  const view = selectViewById(state, viewId);
  try {
    return view && view.style && JSON.parse(view.style);
  } catch {
    return null;
  }
};

export const selectShowViewBanner = state => !selectIsEmbed(state);
